import Logo from "./Logo";
import { connect } from "react-redux";
import { getRemoteConfig } from "shared/store/remoteConfigs/selectors";

const mapStateToProps = (state: any) => {
    return {
        logoUrl: getRemoteConfig(state, "logoUrl"),
    };
};

export default connect(mapStateToProps)(Logo);
